export default __webpack_public_path__ + "static/media/dieppe21.1cbe2261.jpg";